function initTfSwiper() {
  const swipers = document.querySelectorAll(".tf-swiper-el");

  swipers.forEach(function (el) {
    let config = {};
    const raw = el.getAttribute("data-swiper");

    if (raw) {
      try {
        config = JSON.parse(raw);
      } catch (e) {
        console.warn("Invalid data-swiper JSON", raw);
      }
    }

    if (el.swiper) {
      el.swiper.destroy(true, true);
    }

    new Swiper(el, config);
  });
}

function slideToEditorBlock(event) {
  if (!event || !event.target) return;

  const slide = event.target.closest(".swiper-slide");
  if (!slide) return;

  const swiperEl = slide.closest(".tf-swiper-el");
  if (!swiperEl || !swiperEl.swiper) return;

  const swiper = swiperEl.swiper;

  let slideIndex = slide.getAttribute("data-swiper-slide-index");

  if (slideIndex !== null) {
    slideIndex = parseInt(slideIndex, 10);
  } else {
    slideIndex = Array.from(slide.parentElement.children).indexOf(slide);
  }

  if (slideIndex < 0) return;

  if (swiper.params.loop) {
    swiper.slideToLoop(slideIndex, 300);
  } else {
    swiper.slideTo(slideIndex, 300);
  }
}

function init() {
  initTfSwiper();
}

document.addEventListener("DOMContentLoaded", init);
document.addEventListener("shopify:section:load", init);
document.addEventListener("shopify:section:select", init);

document.addEventListener("shopify:block:select", function (event) {
  slideToEditorBlock(event);
});
